/**
 * ClassicStackShell — Preset 1 shell.
 *
 * This shell renders the existing BottomNav exactly as the legacy app did.
 * It exists so that the preset engine can "swap in" the classic chrome
 * without App.js having to branch. Visually byte-safe vs. the pre-preset
 * implementation.
 */
import { useLocation } from "react-router-dom";
import { BottomNav } from "@/components/layout/Navigation";

export default function ClassicStackShell({ children }) {
    const location = useLocation();
    const path = location.pathname;
    const isTenantHost = (() => {
        if (typeof window === "undefined") return false;
        const host = (window.location.hostname || "").toLowerCase().split(":")[0];
        return (
            host &&
            host !== "multiple.games" &&
            host !== "www.multiple.games" &&
            host !== "zone.multiple.games" &&
            host !== "localhost" &&
            !host.startsWith("127.") &&
            !host.startsWith("10.") &&
            !host.startsWith("192.168.") &&
            !host.endsWith(".local")
        );
    })();
    // /clubs has its own BottomNav; suppress the legacy preset one to avoid stacking.
    // Also suppress on guest/auth surfaces (login/signup/forgot/magic-link/set-password)
    // and on landing/legal/rules pages — a navbar with Wallet/Games/Referrals next to a
    // login form is misleading and reads like a "guest preview".
    const hideNav =
        isTenantHost ||
        path === "/" ||
        path === "/login" ||
        path === "/signup" ||
        path === "/landing" ||
        path === "/terms" ||
        path === "/privacy" ||
        path.startsWith("/plans") ||
        path.startsWith("/clubs") ||
        path.startsWith("/admin") ||
        path.startsWith("/superadmin") ||
        path.startsWith("/support") ||
        path.startsWith("/vendor") ||
        path.startsWith("/v/") ||
        path.startsWith("/c/") ||
        path.startsWith("/auth/") ||
        path.startsWith("/rules/");
    return (
        <div data-preset-shell="classic_stack_bottomnav" className="bg-white">
            {children}
            {!hideNav && <BottomNav />}
        </div>
    );
}
